import CloseIcon from '@rsuite/icons/Close'
import { Close, Search } from '@rsuite/icons'
import ReloadIcon from '@rsuite/icons/Reload'
import SearchIcon from '@rsuite/icons/Search'
import { Button, DatePicker } from 'antd'
import dayjs from 'dayjs'
import { isEmpty } from 'lodash'
import { useEffect, useRef, useState } from 'react'
import { FaPlus, FaSync } from 'react-icons/fa'
import { RiDeleteBin6Line } from 'react-icons/ri'
import Select from 'rsuite/SelectPicker'
import Loader from 'rsuite/Loader'
import Input from 'rsuite/Input'
import InputGroup from 'rsuite/InputGroup'
import { ItemType, StateParamsModel } from '../Model'
import CheckPermissions from '../checkPermission'
import { Select as SelectAntd } from 'antd'

//includes
import { Form, Formik } from 'formik'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { handleLabelNameChanges } from 'src/cms/helpers/automation'
import DatePickerForGrievance from 'src/cms/helpers/components/forms/DatePickerForGrievance'
import { ISettingTypeState } from '../../siteSettings/components/settings'
import SortModal from './sortModal'

interface Props {
  moduleName?: any
  params?: StateParamsModel
  setParams?: any
  filterSelect?: boolean
  filterSelectOptions?: { label: string; value: string | number }[]
  onFilterSelectChange?: (value: string | number) => void
  filterSelectPlaceholder?: string
  filterSelectValue?: string | number

  searchTypeSelect?: boolean
  searchTypeSelectOptions?: { label: string; value: string | number }[]
  onSearchTypeSelectChange?: (value: string | number) => void
  searchTypeSelectPlaceholder?: string
  searchTypeSelectValue?: string | number

  secondaryFilterSelect?: boolean
  secondaryFilterSelectOptions?: { label: string; value: string | number }[]
  onSecondaryFilterSelectChange?: (value: string | number) => void
  secondaryFilterSelectPlaceholder?: string
  secondaryFilterSelectValue?: string | number

  tertiaryFilterSelect?: boolean
  tertiaryFilterIsMultiple?: boolean
  tertiaryFilterSelectOptions?: { label: string; value: string | number }[]
  onTertiaryFilterSelectChange?: (value: string | number | any) => void
  tertiaryFilterSelectPlaceholder?: string
  tertiaryFilterSelectValue?: string | number | any

  fourthFilterSelect?: boolean
  fourthFilterSelectOptions?: { label: string; value: string | number }[]
  onFourthFilterSelectChange?: (value: string | number) => void
  fourthFilterSelectPlaceholder?: string
  fourthFilterSelectValue?: string | number

  fifthFilterSelect?: boolean
  fifthFilterSelectOptions?: { label: string; value: string | number }[]
  onFifthFilterSelectChange?: (value: string | number) => void
  fifthFilterSelectPlaceholder?: string
  fifthFilterSelectValue?: string | number

  sixthFilterSelect?: boolean
  sixthFilterSelectOptions?: { label: string; value: string | number }[]
  onSixthFilterSelectChange?: (value: string | number) => void
  sixthFilterSelectPlaceholder?: string
  sixthFilterSelectValue?: string | number

  seventhFilterSelect?: boolean
  seventhFilterIsMultiple?: boolean
  seventhFilterSelectOptions?: { label: string; value: string | number }[]
  onSeventhFilterSelectChange?: (value: string | number | any) => void
  seventhFilterSelectPlaceholder?: string
  seventhFilterSelectValue?: string | number | any

  eighthFilterSelect?: boolean
  eighthFilterSelectOptions?: { label: string; value: string | number }[]
  onEighthFilterSelectChange?: (value: string | number) => void
  eighthFilterSelectPlaceholder?: string
  eighthFilterSelectValue?: string | number

  ninthFilterSelect?: boolean
  ninthFilterSelectOptions?: { label: string; value: string | number }[]
  onNinthFilterSelectChange?: (value: string | number) => void
  ninthFilterSelectPlaceholder?: string
  ninthFilterSelectValue?: string | number

  onClearFilters?: () => void
  handleAddModal?: () => void
  handleAddStatus?: () => void
  handleAddNotice?: () => void
  handleAddNotice1?: () => void
  handleAlertOpen?: () => void
  handleSyncAlertOpen?: () => void
  enableMultiple?: () => void
  disableMultiple?: () => void
  handleExport?: () => void
  handleRefresh?: () => void
  handleGetAllData?: () => void
  handleTemplateExport?: () => void
  templateLinkShow?: boolean
  templateButtonName?: string
  handleImport?: any
  handleClickImport?: any
  filterData?: boolean
  filterByBranch?: boolean
  filtersInline?: boolean
  addShow?: boolean
  updateShow?: boolean
  showDateFilter?: boolean
  addNoteShow?: boolean
  addNoteMemberTypeShow?: any
  addNoteShow1?: boolean
  showReload?: boolean
  deleteShow?: boolean
  exportShow?: boolean
  exportLoading?: boolean
  importShow?: boolean
  importShow1?: boolean
  syncButtonShow?: boolean
  syncButtonName?: string
  syncButton?: () => void
  toggleMultipleShow?: boolean
  disableButton?: boolean
  exportButtonName?: string
  sortShow?: boolean
  sortButtonName?: string
  activeButtonName?: any
  inactiveButtonName?: string
  openSortModal?: boolean
  setOpenSortModal?: any
  data?: Array<{ [key: string]: string | number }> | undefined
  handleSubmitSort?: (data: Array<ItemType>) => void
  loading?: boolean
  downloadResumeShow?: boolean
  groupDiscussion?: boolean
  interview?: boolean
  handleDownloadResume?: () => void
  enableDiscussion?: () => void
  enableInterview?: () => void

}

const { RangePicker } = DatePicker

const DesignComponent = ({
  moduleName,
  params,
  setParams,
  groupDiscussion = false,
  interview = false,
  onClearFilters,
  handleAddModal,
  handleAddStatus,
  handleAddNotice,
  handleAddNotice1,
  handleAlertOpen,
  handleSyncAlertOpen,
  handleClickImport,
  handleExport,
  enableMultiple,
  disableMultiple,
  handleRefresh,
  handleGetAllData,
  handleTemplateExport,
  handleImport,
  showDateFilter = false,
  templateLinkShow = false,
  templateButtonName,
  filterData = false,
  filterByBranch = false,
  filtersInline = false,
  addShow = true,
  updateShow = false,
  addNoteShow = false,
  addNoteMemberTypeShow = false,
  addNoteShow1 = false,
  showReload = true,
  deleteShow = true,
  exportShow = true,
  exportLoading = false,
  importShow = true,
  importShow1 = false,
  toggleMultipleShow = true,
  syncButtonShow = false,
  syncButtonName = 'Sync',
  syncButton,
  exportButtonName,
  sortShow,
  sortButtonName,
  activeButtonName,
  inactiveButtonName,
  disableButton,
  data,
  openSortModal,
  setOpenSortModal,
  handleSubmitSort,
  loading,
  handleDownloadResume,
  downloadResumeShow,
  enableDiscussion,
  enableInterview,
  filterSelect = false,
  filterSelectOptions,
  onFilterSelectChange,
  filterSelectPlaceholder,
  filterSelectValue,
  searchTypeSelect = false,
  searchTypeSelectOptions,
  onSearchTypeSelectChange,
  searchTypeSelectPlaceholder,
  searchTypeSelectValue,
  secondaryFilterSelect = false,
  secondaryFilterSelectOptions,
  onSecondaryFilterSelectChange,
  secondaryFilterSelectPlaceholder,
  secondaryFilterSelectValue,
  tertiaryFilterSelect = false,
  tertiaryFilterSelectOptions,
  onTertiaryFilterSelectChange,
  tertiaryFilterSelectPlaceholder,
  tertiaryFilterSelectValue,
  tertiaryFilterIsMultiple = false,
  fourthFilterSelect = false,
  fourthFilterSelectOptions,
  onFourthFilterSelectChange,
  fourthFilterSelectPlaceholder,
  fourthFilterSelectValue,
  fifthFilterSelect = false,
  fifthFilterSelectOptions,
  onFifthFilterSelectChange,
  fifthFilterSelectPlaceholder,
  fifthFilterSelectValue,
  sixthFilterSelect = false,
  sixthFilterSelectOptions,
  onSixthFilterSelectChange,
  sixthFilterSelectPlaceholder,
  sixthFilterSelectValue,
  seventhFilterSelect = false,
  seventhFilterSelectOptions,
  onSeventhFilterSelectChange,
  seventhFilterSelectPlaceholder,
  seventhFilterSelectValue,
  seventhFilterIsMultiple = false,
  eighthFilterSelect = false,
  eighthFilterSelectOptions,
  onEighthFilterSelectChange,
  eighthFilterSelectPlaceholder,
  eighthFilterSelectValue,
  ninthFilterSelect = false,
  ninthFilterSelectOptions,
  onNinthFilterSelectChange,
  ninthFilterSelectPlaceholder,
  ninthFilterSelectValue,
}: Props) => {
  const [sortData, setSortData] = useState<Array<ItemType>>([])
  const [searchQuery, setSearchQuery] = useState(params?.search ?? '')
  const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const searchDebounceArmedRef = useRef(false)
  const [branch, setBranch] = useState<string | null>('')
  const [searchType, setSearchType] = useState<string | number | null>('')

  ///just for menu manager
  const setSortInnerData = (data: Array<any>) => {
    if (data.length > 0) {
      const parentIndex = sortData.findIndex((item) => item.keyId === data[0]?.parentId)
      const updatedSortData = [...sortData]
      if (parentIndex >= 0) {
        updatedSortData[parentIndex].children = data
      }
      setSortData(updatedSortData)
    }
  }
  ///just for menu manager
  const setSortInnerMostData = (data: Array<any>) => {
    if (data?.length > 0) {
      const gParentIndex = sortData?.findIndex((item) => item.keyId === data[0]?.topmenuId)

      const parentIndex = sortData[gParentIndex]?.children?.findIndex(
        (item: any) => item.id === data[0]?.parentId
      )

      const updatedSortData = [...sortData]
      if (!isEmpty(updatedSortData?.[gParentIndex]?.children)) {
        if (!isEmpty(updatedSortData?.[gParentIndex]?.children?.[parentIndex]?.children)) {
          updatedSortData[gParentIndex].children[parentIndex].children = [...data]
        }
      }
      setSortData([...updatedSortData])
    }
  }
  const setSortInnerMostChildData = (
    data: Array<any>,
    index1: number,
    index2: number,
    index3: number
  ) => {
    if (data?.length > 0 && index1 >= 0 && index2 >= 0 && index3 >= 0) {
      const updatedSortData = [...sortData]

      if (!isEmpty(updatedSortData?.[index1]?.children)) {
        if (!isEmpty(updatedSortData?.[index1]?.children?.[index2]?.children)) {
          if (!isEmpty(updatedSortData?.[index1]?.children?.[index2]?.children[index3].children)) {
            updatedSortData[index1].children[index2].children[index3].children = [...data]
          }
        }
      }
      setSortData([...updatedSortData])
    }
  }

  useEffect(() => {
    if (!isEmpty(data)) {
      let newSortData: any = data
        ? data?.map((item, i) => {
          return {
            id: i,
            keyId: item?.id,
            name: item?.name,
            title: item?.title,
            parentId: item?.parentId ? item?.parentId : null,
            children: !isEmpty(item?.children) ? item?.children : null,
            menuType: item.menuType,
          }
        })
        : []
      setSortData(newSortData)
    }
  }, [data])

  const handleCloseOpenSortModal = () => {
    setOpenSortModal(false)
  }

  useEffect(() => {
    // Skip the mount pass. `searchQuery` is seeded from `params.search`, so the first run
    // debounced a setParams that changed no actual query -- it only spread in empty
    // `search`/`search_type` keys. That is still a brand new params object, so every
    // listing screen that fetches on `[params]` issued a second, identical request ~400ms
    // after load. Only a real edit to the query should push params now.
    if (!searchDebounceArmedRef.current) {
      searchDebounceArmedRef.current = true
      return
    }
    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current)
    debounceTimerRef.current = setTimeout(() => {
      setParams({ ...params, page: 1, search: searchQuery, search_type: searchTypeSelectValue ?? '' })
    }, 400)
    return () => {
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current)
    }
  }, [searchQuery, searchTypeSelectValue])
  const settings: ISettingTypeState = useSelector((state: any) => state.settingType)

  const FILTER_WIDTH = 200
  const FILTER_HEIGHT = 40

  const filtersConfig = [
    {
      enabled: filterSelect,
      options: filterSelectOptions,
      value: filterSelectValue,
      placeholder: filterSelectPlaceholder,
      onChange: onFilterSelectChange,
    },
    {
      enabled: secondaryFilterSelect,
      options: secondaryFilterSelectOptions,
      value: secondaryFilterSelectValue,
      placeholder: secondaryFilterSelectPlaceholder,
      onChange: onSecondaryFilterSelectChange,
    },
    {
      enabled: tertiaryFilterSelect,
      options: tertiaryFilterSelectOptions,
      value: tertiaryFilterSelectValue,
      placeholder: tertiaryFilterSelectPlaceholder,
      onChange: onTertiaryFilterSelectChange,
      multiple: tertiaryFilterIsMultiple,
    },
    {
      enabled: fourthFilterSelect,
      options: fourthFilterSelectOptions,
      value: fourthFilterSelectValue,
      placeholder: fourthFilterSelectPlaceholder,
      onChange: onFourthFilterSelectChange,
    },
    {
      enabled: fifthFilterSelect,
      options: fifthFilterSelectOptions,
      value: fifthFilterSelectValue,
      placeholder: fifthFilterSelectPlaceholder,
      onChange: onFifthFilterSelectChange,
    },
    {
      enabled: sixthFilterSelect,
      options: sixthFilterSelectOptions,
      value: sixthFilterSelectValue,
      placeholder: sixthFilterSelectPlaceholder,
      onChange: onSixthFilterSelectChange,
    },
    {
      enabled: seventhFilterSelect,
      options: seventhFilterSelectOptions,
      value: seventhFilterSelectValue,
      placeholder: seventhFilterSelectPlaceholder,
      onChange: onSeventhFilterSelectChange,
      multiple: seventhFilterIsMultiple,
    },
    {
      enabled: eighthFilterSelect,
      options: eighthFilterSelectOptions,
      value: eighthFilterSelectValue,
      placeholder: eighthFilterSelectPlaceholder,
      onChange: onEighthFilterSelectChange,
    },
    {
      enabled: ninthFilterSelect,
      options: ninthFilterSelectOptions,
      value: ninthFilterSelectValue,
      placeholder: ninthFilterSelectPlaceholder,
      onChange: onNinthFilterSelectChange,
    },
  ]


  const showProductAndInterest =
    settings?.data?.setting?.filter((d) => d.name === 'showPopularityAndInterest')[0]?.value === '1'
      ? true
      : false

  return (
    <>
      {/* ── Page title ── */}
      <div className='row g-0 border-bottom align-items-center mb-3 py-3'>
        <div className='col-12'>
          <div
            className='heading__component__title fw-bolder'
            data-cy={moduleName ? `${handleLabelNameChanges(moduleName)}-title` : ''}
          >
            {moduleName}
          </div>
        </div>
      </div>

      {/* ── Filter & Actions Card ── */}
      {(() => {
        const hasFilters =
          filterByBranch || filtersConfig.some(({ enabled, options }) => enabled && options)

        const activeFilterCount = filtersConfig.filter(
          ({ enabled, options, value }) => enabled && options && !isEmpty(value?.toString())
        ).length

        const hasActionBar =
          showReload || syncButtonShow || addNoteShow || addNoteMemberTypeShow ||
          addNoteShow1 || downloadResumeShow || toggleMultipleShow || exportShow ||
          importShow || importShow1 || sortShow || templateLinkShow ||
          (showProductAndInterest && (groupDiscussion || interview))

        // Filter-select controls, shared between the inline (same row as search) and
        // the stacked grid (its own row) layouts.
        const filterSelectEls = (
          <>
            {filterByBranch && (
              <Select
                data={[]}
                placeholder='Filter by Branch'
                style={{ height: 36 }}
                onChange={() => setBranch('')}
              />
            )}
            {filtersConfig.map(
              ({ enabled, options, value, placeholder, onChange, multiple }, idx) =>
                enabled && options && (
                  <SelectAntd
                    key={idx}
                    mode={multiple ? 'multiple' : undefined}
                    style={{ height: 36, minWidth: 200 }}
                    placeholder={placeholder || 'Select'}
                    value={value || undefined}
                    onChange={onChange}
                    options={options}
                    allowClear
                    showSearch
                    optionFilterProp='label'
                    maxTagCount={multiple ? 1 : undefined}
                  />
                )
            )}
          </>
        )

        return (
          <div className='filter-section-wrapper mb-4'>

            {/* Row 1 – Search controls + primary CTA buttons */}
            <div className='filter-card-top'>
              <div className='filter-header'>
                {searchTypeSelect && searchTypeSelectOptions && (
                  <SelectAntd
                    style={{ width: 140, height: 36 }}
                    placeholder={searchTypeSelectPlaceholder || 'Search by'}
                    value={searchTypeSelectValue || undefined}
                    // onChange={(value) => setSearchType(value)}
                    onChange={onSearchTypeSelectChange}
                    options={searchTypeSelectOptions}
                    allowClear
                    showSearch
                    optionFilterProp='label'
                  />
                )}
                {searchTypeSelect && searchTypeSelectOptions && <div className='filter-divider' />}
                <InputGroup inside style={{ flex: 1, minWidth: 200, maxWidth: 340 }}>
                  <Input
                    placeholder='Search...'
                    value={searchQuery}
                    onChange={(value) =>
                      setSearchQuery(value)
                    }
                    data-cy='search-field'
                  />
                  <InputGroup.Addon>
                    {!isEmpty(searchQuery) ? (
                      <Close
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current)
                          setSearchQuery('')
                          setParams({ ...params, page: 1, search: '' })
                        }}
                        data-cy='search-close-button'
                      />
                    ) : (
                      <Search />
                    )}
                  </InputGroup.Addon>
                </InputGroup>

                {showDateFilter && (
                  <>
                    <div className='filter-divider' />
                    <div className='range-picker-ant-picker range-design'>
                      <RangePicker
                        placement='bottomLeft'
                        popupStyle={{ zIndex: 1000 }}
                        size='middle'
                        value={
                          params?.fromDate && params?.toDate
                            ? [
                                dayjs(String(params.fromDate).replace(/\//g, '-')),
                                dayjs(String(params.toDate).replace(/\//g, '-')),
                              ]
                            : null
                        }
                        onChange={(date: any) => {
                          if (!date || !date[0] || !date[1]) {
                            setParams({ ...params, fromDate: '', toDate: '' })
                          } else {
                            setParams({
                              ...params,
                              fromDate: dayjs(date[0]).format('YYYY/MM/DD'),
                              toDate: dayjs(date[1]).format('YYYY/MM/DD'),
                            })
                          }
                        }}
                      />
                    </div>
                  </>
                )}

                {filtersInline && hasFilters && (
                  <>
                    <div className='filter-divider' />
                    {filterSelectEls}
                  </>
                )}

                {activeFilterCount > 0 && <div className='filter-divider' />}
                {activeFilterCount > 0 && (
                  <span className='filters-active-indicator'>
                    {activeFilterCount} filter{activeFilterCount > 1 ? 's' : ''} active
                  </span>
                )}
                {onClearFilters && (activeFilterCount > 0 || searchQuery !== '') && (
                  <>
                    <div className='filter-divider' />
                    <button
                      className='dc-btn dc-btn-clear'
                      title='Clear all filters and search'
                      onClick={() => {
                        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current)
                        setSearchQuery('')
                        onClearFilters()
                      }}
                    >
                      <CloseIcon />
                      Clear
                    </button>
                  </>
                )}
              </div>

              {/* Primary action buttons: Add / Update Status / Delete */}
              <div className='filter-primary-actions'>
                {addShow && (
                  <CheckPermissions type='Add'>
                    <button
                      className='dc-btn dc-btn-primary'
                      onClick={handleAddModal}
                      data-cy='add-button'
                    >
                      <FaPlus />
                      Add
                    </button>
                  </CheckPermissions>
                )}
                {updateShow && (
                  <CheckPermissions type='Add'>
                    <button
                      className='dc-btn dc-btn-primary'
                      onClick={handleAddStatus}
                      data-cy='update-button'
                      data-cy-outer='design-update-status-button'
                    >
                      <FaPlus />
                      Update Status
                    </button>
                  </CheckPermissions>
                )}
                {deleteShow && (
                  <CheckPermissions type='Delete'>
                    <button
                      className='dc-btn dc-btn-danger'
                      onClick={handleAlertOpen}
                      data-cy='delete-button'
                    >
                      <RiDeleteBin6Line />
                      Delete
                    </button>
                  </CheckPermissions>
                )}
              </div>
            </div>

            {/* Row 2 – Filter selects (only when not rendered inline in the search row) */}
            {hasFilters && !filtersInline && (
              <div className='filters-grid'>
                {filterSelectEls}
              </div>
            )}

            {/* Row 3 – Secondary action buttons */}
            {hasActionBar && (
              <div className='filter-action-bar'>
                {showReload && (
                  <button
                    className='dc-btn dc-btn-icon'
                    onClick={handleRefresh}
                    data-cy='refresh-button'
                    title='Refresh'
                  >
                    <ReloadIcon />
                  </button>
                )}
                {syncButtonShow && (
                  <button
                    className='dc-btn dc-btn-outline'
                    onClick={handleSyncAlertOpen}
                    data-cy='refresh-button'
                  >
                    <FaSync />
                    {syncButtonName}
                  </button>
                )}
                <div className='filter-action-spacer' />

                {addNoteShow && (
                  <CheckPermissions type='Add'>
                    <button
                      className='dc-btn dc-btn-outline'
                      onClick={handleAddNotice}
                      data-cy='update-note-button'
                    >
                      {addNoteShow1 ? 'Update Deposit Note' : 'Update Note'}
                    </button>
                  </CheckPermissions>
                )}
                {addNoteMemberTypeShow && (
                  <CheckPermissions type='Add'>
                    <button
                      className='dc-btn dc-btn-outline'
                      onClick={handleAddNotice}
                      data-cy='update-member-note-button'
                    >
                      {addNoteShow1 ? 'Update Deposit Note' : 'Update Note'}
                    </button>
                  </CheckPermissions>
                )}
                {addNoteShow1 && (
                  <CheckPermissions type='Add'>
                    <button
                      className='dc-btn dc-btn-outline'
                      onClick={handleAddNotice1}
                      data-cy='update-loan-note-button'
                    >
                      Update Loan Note
                    </button>
                  </CheckPermissions>
                )}
                {downloadResumeShow && (
                  <CheckPermissions type='Add'>
                    <button
                      className='dc-btn dc-btn-outline'
                      onClick={handleDownloadResume}
                      data-cy='download-document-button'
                    >
                      Download Document
                    </button>
                  </CheckPermissions>
                )}
                {showProductAndInterest && groupDiscussion && (
                  <button
                    className='dc-btn dc-btn-outline'
                    onClick={enableDiscussion}
                    disabled={disableButton}
                    data-cy='group-discussion-button'
                  >
                    Shortlist for Group Discussion
                  </button>
                )}
                {showProductAndInterest && interview && (
                  <button
                    className='dc-btn dc-btn-outline'
                    onClick={enableInterview}
                    disabled={disableButton}
                    data-cy='interview-button'
                  >
                    Shortlist for Interview
                  </button>
                )}
                {toggleMultipleShow && (
                  <>
                    <button
                      className='dc-btn dc-btn-success'
                      onClick={enableMultiple}
                      disabled={disableButton}
                      data-cy='toggle-multiple-show-button'
                    >
                      {activeButtonName || 'Active'}
                    </button>
                    <button
                      className='dc-btn dc-btn-warning'
                      onClick={disableMultiple}
                      data-cy='toggle-multiple-active-inactive-button'
                    >
                      {inactiveButtonName || 'Inactive'}
                    </button>
                  </>
                )}

                {/* Spacer pushes the following buttons to the right */}

                {templateLinkShow && (
                  <button
                    className='dc-btn dc-btn-outline'
                    onClick={handleTemplateExport}
                    data-cy={`${handleLabelNameChanges(moduleName)}-export-button`}
                  >
                    {templateButtonName}
                  </button>
                )}
                {exportShow && (
                  <button
                    className='dc-btn dc-btn-primary'
                    onClick={handleExport}
                    data-cy='export-button'
                    disabled={exportLoading}
                    style={exportLoading ? { opacity: 0.7, cursor: 'not-allowed' } : undefined}
                  >
                    {exportLoading ? (
                      <>
                        <Loader size='xs' style={{ marginRight: 6 }} />
                        Exporting...
                      </>
                    ) : (
                      exportButtonName || 'Export to CSV'
                    )}
                  </button>
                )}
                {importShow && (
                  <form action='#' style={{ margin: 0 }}>
                    <div className='input-file-container'>
                      <input
                        className='input-file'
                        id='my-file'
                        type='file'
                        onChange={handleImport}
                        data-cy='import-file-link'
                      />
                      <label
                        className='dc-btn dc-btn-outline input-file-trigger'
                        htmlFor='my-file'
                      >
                        Import
                      </label>
                    </div>
                  </form>
                )}
                {importShow1 && (
                  <button
                    className='dc-btn dc-btn-outline'
                    onClick={handleClickImport}
                    data-cy='import-show-button'
                  >
                    Import
                  </button>
                )}
                {sortShow && (
                  <button
                    className='dc-btn dc-btn-outline'
                    onClick={() => {
                      handleGetAllData && handleGetAllData()
                      setOpenSortModal(true)
                    }}
                    data-cy='sort-button'
                  >
                    {sortButtonName || 'Sort'}
                  </button>
                )}
              </div>
            )}
          </div>
        )
      })()}

      <SortModal
        isOpen={openSortModal}
        handleClose={handleCloseOpenSortModal}
        data={sortData}
        setSortData={setSortData}
        sortButtonName={sortButtonName}
        handleSubmitSort={handleSubmitSort}
        loading={loading}
        setSortInnerData={setSortInnerData}
        setSortInnerMostData={setSortInnerMostData}
        setSortInnerMostChildData={setSortInnerMostChildData}
      />
    </>
  )
}

export default DesignComponent
